import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HeroBackground } from "@/components/HeroBackground";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

export default function AuthShell({ title, subtitle, children, footer, testid }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background lg:grid lg:grid-cols-2" data-testid={testid}>
      <div className="hero-navy relative hidden flex-col justify-between p-12 lg:flex">
        <HeroBackground />
        <Link to="/" className="relative"><Logo variant="light" /></Link>
        <div className="relative max-w-md">
          <h2 className="font-heading text-4xl font-extrabold leading-tight text-white">{t("authBrand")}</h2>
          <p className="mt-4 text-slate-300">{t("authBrandSub")}</p>
        </div>
        <div className="relative text-xs text-slate-400">© {new Date().getFullYear()} EmployGuard · {t("footer.rights")}</div>
      </div>
      <div className="flex min-h-screen flex-col justify-center px-6 py-12 sm:px-12 lg:min-h-0">
        <div className="mx-auto w-full max-w-md">
          <div className="mb-8 flex items-center justify-between">
            <Link to="/" className="lg:invisible"><Logo /></Link>
            <LanguageSwitcher />
          </div>
          <h1 className="font-heading text-3xl font-extrabold text-navy">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
